import type { FC, ReactNode } from 'react'

import { FaqList } from '@/components/generals/faq-list'
import { SectionHeading } from '@/components/generals/section-heading'
import { homeFaqs } from '@/constants/content'

export const FaqSection: FC = (): ReactNode => {
    return (
        <section
            id='faq'
            aria-labelledby='faq-title'
            className='bg-background py-20 sm:py-24 lg:py-28'
        >
            <div className='mx-auto max-w-3xl px-5 sm:px-8'>
                <SectionHeading
                    id='faq-title'
                    eyebrow='Questions and answers'
                    title='Frequently asked questions'
                    description='Everything you need to know before your visit. Still curious? Ask our chat assistant or message us on WhatsApp.'
                />

                <FaqList faqs={homeFaqs} className='mt-12' />
            </div>
        </section>
    )
}
